import {
  aboutUs,
  backmarketWarranty,
  blackFriday,
  boMerchant,
  buyBack,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  giftCards,
  giftFinder,
  help,
  hireExternal,
  infosConsumer,
  insurances,
  legal,
  modelsComparison,
  studentGoodDeals,
  termsBuyback,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const esConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [
        aboutUs,
        {
          translationKey: 'press',
          href: '/es-es/about-us#scroll=false&target=heading-2-kit-para-medios',
        },
        hireExternal,
        {
          translationKey: 'trustpilot',
          href: 'https://es.trustpilot.com/review/www.backmarket.es',
        },
      ],
      socials: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/backmarket_es',
        },
        {
          name: 'linkedin',
          href: 'https://www.linkedin.com/company/back-market',
        },
        {
          name: 'facebook',
          href: 'https://www.facebook.com/backmarket.es',
        },
        { name: 'x', href: 'https://x.com/back_market_es' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'contactUs',
          href: 'https://help.backmarket.com/hc/es/articles/360026654654--C%C3%B3mo-contacto-con-la-Atenci%C3%B3n-al-cliente-de-Back-Market',
        },
        help,
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/es/articles/360026646054--En-qu%C3%A9-pa%C3%ADs-me-pueden-entregar-y-cu%C3%A1nto-me-cuesta',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/es/categories/360002106194-Devoluciones-y-reembolsos--%CE%95%CF%80%CE%B9%CF%83%CF%84%CF%81%CE%BF%CF%86%CE%AD%CF%82-%CE%91%CF%80%CE%BF%CE%B6%CE%B7%CE%BC%CE%B9%CF%8E%CF%83%CE%B5%CE%B9%CF%82-Reso-del-prodotto-e-rimborsi-Returns-Refunds--Retours-Remboursements-Retouren-en-terugbetalingen-Returns-refunds-',
        },
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [
        backmarketWarranty,
        insurances,
        buyBack,
        studentGoodDeals,
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.es/es-es/seller/home',
        },
        boMerchant,
      ],
      payment: {
        translationKey: 'paymentMethods',
        href: 'https://help.backmarket.com/hc/es/articles/360026643854--Qu%C3%A9-m%C3%A9todos-de-pago-se-aceptan-en-Back-Market',
      },
    },
    {
      titleKey: 'categoryGuides',
      links: [
        giftCards,
        buyingGuides,
        modelsComparison,
        giftFinder,
        blackFriday,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        termsBuyback,
        cookiePolicy,
        dataProtection,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/es/requests/new?ticket_form_id=12226993197084',
        },
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
